export type SendTokenRequest = {
    to: string;
    amount: string;
    mint: string;
};

export type SendTokenResponse = {
    id: string;
};

type SendTokenAction = (wallet: string, req: SendTokenRequest, abortController?: AbortController) => void
export const useSendToken = (): [
        SendTokenResponse | undefined,
    boolean,
        Error | undefined,
    SendTokenAction
] => {
    // const auth = useAuth();
    // const [post, response, loading, error] = usePost<SendTokenResponse>()
    // const fn = useCallback(async (wallet: string, req: SendTokenRequest, abortController?: AbortController) =>
    //     post(`/v1/wallets/${wallet}/send`, req, abortController), [auth]
    // )
    // return [fn, response, loading, error] as const
    throw new Error('not implemented');
}


export type AwaitConfirmedTransactionResponse = {
    id: string;
};

type AwaitConfirmedTransactionAction = (request: string, abortController?: AbortController) => void
export const useAwaitConfirmedTransaction = (): [
        AwaitConfirmedTransactionResponse | undefined,
    boolean,
        Error | undefined,
    AwaitConfirmedTransactionAction
] => {
    // const auth = useAuth();
    // const [get, response, loading, error] = useGet<AwaitConfirmedTransactionResponse>()
    // const fn = useCallback(async (request: string, abortController?: AbortController) =>
    //     get(`/v1/requests/${request}`, abortController), [auth]
    // )
    // return [fn, response, loading, error] as const
    throw new Error('not implemented');
}
